import { Message } from "aderant-conflicts-models";

export const Messages = {
    NEW_SEARCH_REQUEST_BUTTON: new Message("NEW_SEARCH_REQUEST_BUTTON", "New Search Request"),
    NEW_QUICK_SEARCH_BUTTON: new Message("NEW_QUICK_SEARCH_BUTTON", "New Quick Search"),
    SEARCH_FAILED_INCORRECT_SYNTAX: new Message("SEARCH_FAILED_INCORRECT_SYNTAX", "Search failed because of incorrect syntax.")
};
